import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, space, media } = theme

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${colors['neutral-background-contrast']};
  padding: ${space['spacing-giga']} 0;
  text-align: center;

  a {
    text-decoration: underline;
    color: inherit;
  }
  
  @media (${media.phone}){
    padding: ${space['spacing-xxl']} ${space['spacing-md']};
  }
`